"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'password.reset.hero.title': '忘记密码了？',
    'password.reset.hero.description': '别担心，这种情况很常见。输入您的电子邮件地址，我们将向您发送重置密码的链接。',
    'password.reset.hero.login_link_text': '想起密码了？',
    'password.reset.hero.login_link': '点击登录',
    'password.reset.page.title': '密码重置',
    'password.reset.form.title': '重置您的密码',
    'password.reset.email.label': '电子邮件地址',
    'password.reset.email.placeholder': '输入您的电子邮件地址',
    'password.reset.submit': '发送重置链接',
    'password.reset.backToLogin': '返回登录',
    'password.reset.success.title': '邮件已发送！',
    'password.reset.success.description': '请查看您的电子邮件，获取重置密码的说明。',
    'password.reset.confirm.hero.title': '设置新密码',
    'password.reset.confirm.hero.description': '创建一个您能记住的强密码。您的新密码应该与之前的密码不同。',
    'password.reset.confirm.hero.login_link_text': '想起密码了？',
    'password.reset.confirm.hero.login_link': '点击登录',
    'password.reset.confirm.page.title': '设置新密码',
    'password.reset.confirm.form.title': '创建新密码',
    'password.reset.confirm.password.label': '新密码',
    'password.reset.confirm.password.placeholder': '输入新密码',
    'password.reset.confirm.confirmPassword.label': '确认密码',
    'password.reset.confirm.confirmPassword.placeholder': '确认新密码',
    'password.reset.confirm.submit': '重置密码',
    'password.reset.confirm.success.title': '密码已重置！',
    'password.reset.confirm.success.description': '您的密码已成功重置。现在您可以使用新密码登录。',
};
